/**
 * Query string compartida entre pasos del cuestionario (?id=&token=)
 */
export function buildCuestionarioSearch(id, token) {
    if (!id) return '';
    let s = `?id=${encodeURIComponent(String(id))}`;
    if (token) s += `&token=${encodeURIComponent(String(token))}`;
    return s;
}

/** Códigos de tipo documento válidos en el cuestionario (RIPS / DIAN). */
const TIPOS_DOC_VALIDOS = new Set([
    'CC', 'CE', 'CD', 'CN', 'DE', 'MS', 'NIP', 'NIT', 'PA', 'PT', 'PE', 'RC', 'TI', 'SC', 'SI', 'AS',
]);

/** Incluye `token` en el body para rutas `*-publico` del cuestionario por correo. */
export function withCuestionarioToken(payload, token) {
    const out = payload && typeof payload === 'object' ? { ...payload } : {};
    if (token != null && token !== '') {
        out.token = token;
    }
    return out;
}

export function normalizarTipoDocumentoCuestionario(valor) {
    if (valor === null || valor === undefined) return 'CC';
    const u = String(valor).trim().toUpperCase();
    if (!u) return 'CC';
    return TIPOS_DOC_VALIDOS.has(u) ? u : 'CC';
}
